import { render, staticRenderFns } from "./CrmSalonFiche.vue?vue&type=template&id=21cd4bdc&"
import script from "./CrmSalonFiche.vue?vue&type=script&lang=js&"
export * from "./CrmSalonFiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports